import { useEffect } from 'react';
import { useCheckoutState } from '../../utils/checkoutState';
import redirect from '../../utils/redirect';
import { pushErrorTrackingEventFromErrorObject } from '../../utils/tracking';

type ComputopPaymentProps = {
  onError: () => void;
};

const ComputopPayment = ({ onError }: ComputopPaymentProps) => {
  const { checkoutState } = useCheckoutState();
  const url = checkoutState.orderConfirmation?.redirect?.url;
  useEffect(() => {
    const onMessage = (event: MessageEvent) => {
      if (!event.data || event.data.type !== 'paymentCallback') {
        return;
      }
      if (event.data.status === 'success' && !!event.data.redirect) {
        redirect(event.data.redirect);
      } else {
        onError();
        pushErrorTrackingEventFromErrorObject(undefined, 'computop');
      }
    };
    window.addEventListener('message', onMessage);
    return () => {
      window.removeEventListener('message', onMessage);
    };
  }, [onError]);

  return <iframe src={url} style={{ height: '100%', width: '100%', border: 'none' }} />;
};

export default ComputopPayment;
